/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

import '@hotwired/turbo-rails'
import 'controllers'
import * as ActiveStorage from "@rails/activestorage"
import '../shared_access_validator'
import '../utils/form_validation_helpers'

import intlTelInput from 'intl-tel-input'
import { parsePhoneNumberFromString, AsYouType } from 'libphonenumber-js'

window.intlTelInput = intlTelInput
window.libphonenumber = { parsePhoneNumberFromString, AsYouType }

// import("@fortawesome/fontawesome-pro/js/all");

require("trix")
require("@rails/actiontext")

document.addEventListener("trix-file-accept", function(event) {
  event.preventDefault();
});

document.addEventListener("turbo:frame-missing", function(event) {
  const { response } = event.detail;
  event.preventDefault();
  const status = response ? response.status : 500;
  const message = status === 404 
    ? "O recurso solicitado não foi encontrado (404)." 
    : `Ocorreu um erro ao carregar o conteúdo (${status}).`;

  const alertId = `turbo-error-${Date.now()}`;
  const alertHtml = `
    <div id="${alertId}" class="alert-danger alert alert-dismissible fade show my-2" role="alert">
      <div>${message}</div>
      <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
    </div>
  `;

  const scheduleAutoClose = (elementId) => {
    setTimeout(() => {
      const el = document.getElementById(elementId);
      if (el) {
        if (window.bootstrap?.Alert) {
          window.bootstrap.Alert.getOrCreateInstance(el)?.close();
        } else {
          el.remove();
        }
      }
    }, 5000);
  };

  const modalElement = event.target?.closest ? event.target.closest('.modal, [data-controller~="remote-modal"]') : null;
  const modalFlashContainer = modalElement
    ? modalElement.querySelector("#remote-modal-flash-messages")
    : document.querySelector(".modal.show #remote-modal-flash-messages");

  if (modalFlashContainer) {
    modalFlashContainer.innerHTML = alertHtml;
    modalFlashContainer.scrollIntoView({ behavior: "smooth", block: "nearest" });
    scheduleAutoClose(alertId);
    return;
  }

  const flashContainer = document.getElementById("flash-messages");
  if (flashContainer) {
    flashContainer.innerHTML = alertHtml;
    window.scrollTo({ top: 0, behavior: "smooth" });
    scheduleAutoClose(alertId);
  } else if (window.toastr) {
    window.toastr.error(message, "Erro");
  } else {
    alert(message);
  }
});

ActiveStorage.start()
 
// Clean up orphaned Bootstrap tooltips on Turbo updates and modal transitions
const hideAndRemoveTooltips = () => {
  document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((el) => {
    try {
      const instance = window.bootstrap?.Tooltip?.getInstance(el);
      if (instance) {
        instance.hide();
      }
    } catch (e) {}
  });
  document.querySelectorAll('.tooltip.show').forEach((el) => el.remove());
};

document.addEventListener("turbo:before-render", hideAndRemoveTooltips);
document.addEventListener("turbo:before-frame-render", hideAndRemoveTooltips);
document.addEventListener("turbo:visit", hideAndRemoveTooltips);
window.addEventListener("show.bs.modal", hideAndRemoveTooltips);
window.addEventListener("hide.bs.modal", hideAndRemoveTooltips);
